// TODO replace publisher with this
// Discuss
export default class TokboxSelfConnection {
    constructor($injector, connection, pn) {
        this.$injector = $injector;
        this.connection = connection;
        this.pn = pn;
        this.isDestroyed = false;
        this.VideoProviderFactory = $injector.get('VideoProviderFactory');
        this.activeComponents = $injector.get('activeComponents');
    }
    get placeholder() {
        return '';
    }
    get userPicture() {
        return this.pn.userPicture;
    }
    get id() {
        return this.connection.connectionId;
    }
    get hasVideo() {
        return this.VideoProviderFactory.activeProvider.ui.hasVideo;
    }
    get hasAudio() {
        return this.VideoProviderFactory.activeProvider.ui.hasAudio;
    }
    onDestroy() {
        this.isDestroyed = true;
    }
    // ACTIONS
    toggleAudio() {
        if (this.disabled || !this.hasAudio)
            return;
    }
    endCall() {
        if (this.disabled)
            return;
    }
}
